// ----------------------------------------------------------------------
export var Slider = function Slider(_ref) {
  var theme = _ref.theme;
  return {
    MuiSlider: {
      styleOverrides: {
        markLabel: {
          fontSize: 13,
          color: theme.palette.text.disabled
        }
      }
    }
  };
};